import { Component } from '@angular/core';
import { SavestateService } from './savestate.service';
import { Platform } from '@ionic/angular';
import { Keyboard } from '@capacitor/keyboard';
import { StatusBar, Style } from '@capacitor/status-bar';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { HelperService } from './helper.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

// Die aktive Umgebung (Live/Staging/Dev) und alle API-/Storage-URLs verwaltet
// zentral der EnvironmentService (services/environment.service.ts); geladen wird
// sie beim Start via APP_INITIALIZER (app.module). Umschalten: Hidden-Menü im Login.
(window as any).building_temperature = 21;

import { register } from 'swiper/element/bundle';
register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: false,
})
export class AppComponent {
  public appPages = [
    {
      title: 'Projekte',
      url: '/projects',
      icon: 'folder',
    },
    {
      title: 'Synchronisation',
      url: '/sync',
      icon: 'sync',
    },
    {
      title: 'Feedback',
      url: '/feedback',
      icon: 'chatbubble',
    },
    {
      title: 'FAQ',
      url: '/faq',
      icon: 'help',
    },
    {
      title: 'Impressum',
      url: '/imprint',
      icon: 'bookmarks',
    },
    {
      title: 'Datenschutz',
      url: '/privacy',
      icon: 'shield',
    },
    {
      title: 'Lizenzen',
      url: '/licenses',
      icon: 'document-text',
    },
    {
      title: 'Logout',
      url: '/logout',
      icon: 'key',
    },
  ];

  constructor(
    private platform: Platform,
    private ss: SavestateService,
    private h: HelperService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.initializeApp();
  }

  async initializeApp() {
    try {
      console.log('Init Data from App Component');
      let self = this;
      await this.ss.reloadData().then(async function () {
        if (self.platform.is('android') && self.platform.is('hybrid')) {
          const setBackgroundColor = async () => {
            await EdgeToEdge.setBackgroundColor({ color: '#1C2541' });
            await StatusBar.setStyle({ style: Style.Light });
          };
          await setBackgroundColor();
        }

        if (self.platform.is('hybrid')) {
          Keyboard.addListener('keyboardWillShow', (info) => {
            document.activeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          });
        }
      });
    } catch (error) {
      console.log(error);
      this.h.error_message = error;
      this.router.navigate(['/error-view']);
    }
  }

  redirectTo(page: any) {
    if (page.title === 'Synchronisation') {
      this.h.last_route_url = this.router.url;
      console.log('Last Route:', this.h.last_route_url);
    }
    this.router.navigate([page.url]);
  }
}
